import type { ProjectionEvidenceSource } from "./types";

/**
 * Canonical source records used by the clinic success adapter. The roles are
 * intentional: CDC/NASS supplies clinic-level outcome parameters, while SART
 * supplies a comparison benchmark and must not be mixed into a clinic rate.
 */
export const CLINIC_PROJECTION_EVIDENCE: ProjectionEvidenceSource[] = [
  {
    id: "cdc-nass-2022-final-art-success-rates",
    label: "CDC/NASS 2022 Final ART Success Rates",
    role: "parameter_source",
    citation: "CDC National ART Surveillance System, dataset cchw-gdwa",
    url: "https://data.cdc.gov/resource/cchw-gdwa.json",
    population:
      "U.S. reporting ART clinics; clinic-level success cells by treatment type, age band, and egg/embryo source",
    publishedAt: "2022",
    verificationStatus: "verified",
  },
  {
    id: "cdc-nass-2022-services-and-profiles",
    label: "CDC/NASS 2022 Services & Profiles",
    role: "contextual_reference",
    citation: "CDC National ART Surveillance System, dataset ix4g-rt8v",
    url: "https://data.cdc.gov/resource/ix4g-rt8v.json",
    population:
      "U.S. ART clinic identity, reporting status, and descriptive cycle-volume context",
    publishedAt: "2022",
    verificationStatus: "verified",
  },
  {
    id: "sart-national-summary-2024",
    label: "SART National Summary Report",
    role: "contextual_reference",
    citation:
      "Society for Assisted Reproductive Technology national summary report",
    url: "https://www.sart.org/patients/national-summary-report/",
    population:
      "U.S. national benchmark context; not a substitute for a clinic-specific denominator or rate",
    publishedAt: "2024",
    verificationStatus: "verified",
  },
  {
    id: "mclernon-ivf-live-birth-2016",
    label: "McLernon et al. IVF live-birth prediction model",
    role: "parameter_source",
    citation: "BMJ. 2016;355:i5735. doi:10.1136/bmj.i5735. PMID:27834232",
    url: "https://doi.org/10.1136/bmj.i5735",
    population:
      "Population-based linked IVF cycles; transported odds-ratio context for live birth",
    publishedAt: "2016",
    verificationStatus: "verified",
  },
  {
    id: "rittenberg-bmi-ivf-2011",
    label: "Rittenberg et al. BMI and IVF treatment outcomes",
    role: "parameter_source",
    citation:
      "Reprod Biomed Online. 2011;23(4):421-439. doi:10.1016/j.rbmo.2011.06.018",
    url: "https://doi.org/10.1016/j.rbmo.2011.06.018",
    population:
      "Systematic review and meta-analysis of BMI associations with IVF outcomes",
    publishedAt: "2011",
    verificationStatus: "verified",
  },
  {
    id: "waylen-smoking-art-2009",
    label: "Waylen et al. smoking and assisted-reproduction outcomes",
    role: "parameter_source",
    citation: "Hum Reprod Update. 2009;15(1):31-44. doi:10.1093/humupd/dmn046",
    url: "https://doi.org/10.1093/humupd/dmn046",
    population:
      "Meta-analysis of cigarette smoking associations with assisted-reproduction outcomes",
    publishedAt: "2009",
    verificationStatus: "verified",
  },
];
